// extracted by mini-css-extract-plugin
export default {"switcher":"SFnFbHSYgCEN3Wgp8Nj_","switch":"AE4wkTwD4qlSpLTbe4_j"};